import {inject, Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {AttachFileToRecord, RecordCalendarFileParams, GetFilesDataParams} from "../types/file.types";
import {baseUrl} from "../constants/base-url";

@Injectable({
  providedIn: 'root'
})
export class RecordCalendarFilesApiService {
  private http: HttpClient = inject(HttpClient);

  public getFilesData(getFilesDataParams: GetFilesDataParams): Observable<Array<RecordCalendarFileParams>> {
    return this.http.get<Array<RecordCalendarFileParams>>(`${baseUrl}/record-calendar-files`, { params: getFilesDataParams });
  }

  public attachFileToRecord(attachFileToRecord: AttachFileToRecord): Observable<RecordCalendarFileParams> {
    return this.http.post<RecordCalendarFileParams>(`${baseUrl}/record-calendar-files`, attachFileToRecord);
  }

  public deleteFileToRecord(id: number): Observable<void> {
    return this.http.delete<void>(`${baseUrl}/record-calendar-files/${id}`);
  }
}
